import React from "react";
import Marquee from "react-fast-marquee";
import { Container } from "react-bootstrap";
import { FaStar } from "react-icons/fa";
import { primaryColor } from "../../../../Constants/Colors";
import {servicesContent} from "../../../../Constants/content"


const MarqueeBanner = () => {
  return (
    <div  style={{ backgroundColor: primaryColor, color: "#fff", padding: "10px 0" }}>
      <Container fluid>
        <Marquee gradient={false} speed={60} pauseOnHover={true}>
          {servicesContent.map((service, index) => (
            <span
              key={index}
              style={{
                display: "inline-flex",
                alignItems: "center",
                marginRight: "50px",
                fontWeight: "bold",
                fontSize: "1.1rem",
                whiteSpace: "nowrap",
                textTransform: "uppercase",
              }}
            >
              <FaStar style={{ color: "#FFFF00", marginRight: "8px" }} />
              {service}
            </span>
          ))}
        </Marquee>
      </Container>
    </div>
  );
};

export default MarqueeBanner;
